import { render, staticRenderFns } from "./propertyCommunityList.vue?vue&type=template&id=f138fe5a&scoped=true"
import script from "./propertyCommunityList.vue?vue&type=script&lang=js"
export * from "./propertyCommunityList.vue?vue&type=script&lang=js"
import style0 from "./propertyCommunityList.vue?vue&type=style&index=0&id=f138fe5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138fe5a",
  null
  
)

export default component.exports